import Vue from 'vue'

var units = {}
export default units
var myPlugin = {
  install(Vue) {
    Vue.mixin({
      mounted() {},
    })
    Vue.prototype.$units = units

    // convert centimeter to foot
    units.shortDistance = function (paramcm) {
      if (!isFinite(paramcm) || paramcm === null || paramcm === '') {
        return NaN
      }
      if (paramcm === 0) {
        return 0
      }
      const cm = Number(paramcm)
      const foot = Number(30.48)
      const centimeterToFoot = cm / foot
      return centimeterToFoot
    }
    // convert meter to mile
    units.longDistanceMeter = function (parammt) {
      if (!isFinite(parammt) || parammt === null || parammt === '') {
        return NaN
      }
      if (parammt === 0) {
        return 0
      }
      const meter = Number(parammt)
      const meterToMile = meter / 1609.34
      return meterToMile
    }
    // convert kilometer to mile
    units.longDistanceKilometer = function (paramkm) {
      if (!isFinite(paramkm) || paramkm === null || paramkm === '') {
        return NaN
      }
      if (paramkm === 0) {
        return 0
      }
      const km = Number(paramkm)
      const kmToMile = km / 1.60934
      return kmToMile
    }
    // convert liter to gallon imperial (not gallon US)
    units.liquidVolume = function (paramlt) {
      if (!isFinite(paramlt) || paramlt === null || paramlt === '') {
        return NaN
      }
      if (paramlt === 0) {
        return 0
      }
      const liter = Number(paramlt)
      const gallon = Number(4.456)
      const literToGallon = liter / gallon
      return literToGallon
    }
    // convert celsius degrees to fahrenheit degrees
    units.temperature = function (paramcls) {
      if (!isFinite(paramcls) || paramcls === null || paramcls === '') {
        return NaN
      }
      if (paramcls === 0) {
        return 0
      }
      const celsius = Number(paramcls)
      const clsToFahrenheit = celsius * (9 / 5) + 32
      return clsToFahrenheit
    }
    // convert gram to ounce
    units.massGramToOunce = function (paramgm) {
      if (!isFinite(paramgm) || paramgm === null || paramgm === '') {
        return NaN
      }
      if (paramgm === 0) {
        return 0
      }
      const gram = Number(paramgm)
      const gramToOunce = gram / 28.35
      return gramToOunce
    }
    // convert kilo to livre
    units.massKgToLivre = function (paramkg) {
      if (!isFinite(paramkg) || paramkg === null || paramkg === '') {
        return NaN
      }
      if (paramkg === 0) {
        return 0
      }
      const kilo = Number(paramkg)
      const kgToLivre = kilo * 2.205
      return kgToLivre
    }
    // convert ton to long ton (not court tonne US)
    units.massTonToLongTon = function (paramton) {
      if (!isFinite(paramton) || paramton === null || paramton === '') {
        return NaN
      }
      if (paramton === 0) {
        return 0
      }
      const ton = Number(paramton)
      const tonToLongTon = ton / 1.016
      return tonToLongTon
    }
  },
}

Vue.use(myPlugin)
